// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33LkQ","colBig":"styles_colBig__3TeNC","colSmall":"styles_colSmall__2_AQR","shopifyNameWrapper":"styles_shopifyNameWrapper__2YCzN"};